import { LMRAReferenceNumberCard } from "@/services/backend/rlt/work-orders/components/lmra-reference-number-card";
import { useParams } from "react-router";
import { RTKQueryErrorAlert } from "@/shared/components/errors/rtk-query-error-alert";
import { useRltLMRAShowQuery } from "@/services/backend/rlt/work-orders/api/lmra-api";
import { Card } from "@/shared/components/ui/card";
import t from "@/lang/lang";
import { ConfirmedLMRAComponent } from "@/services/backend/rlt/work-orders/components/confirmed-lmra";
import { UnconfirmedLMRAComponent } from "@/services/backend/rlt/work-orders/components/unconfirmed-lmra";

export function WorkOrderExecutionLmraRoute() {
  const { lmraId } = useParams();
  const {
    data: lmra,
    isLoading,
    error,
  } = useRltLMRAShowQuery({
    id: lmraId!,
  });

  if (isLoading) {
    return (
      <Card className="text-muted-foreground animate-pulse p-6">
        {t("Lade Daten...")}
      </Card>
    );
  }

  if (error) {
    return <RTKQueryErrorAlert error={error} />;
  }

  if (!lmra) return null;

  return (
    <div className="space-y-4">
      <LMRAReferenceNumberCard lmra={lmra} />
      {lmra.confirmed ? (
        <ConfirmedLMRAComponent lmra={lmra} />
      ) : (
        <UnconfirmedLMRAComponent lmra={lmra} />
      )}
    </div>
  );
}
